import { render } from "./ResourceCell.vue?vue&type=template&id=3c3a9d32"
import script from "./ResourceCell.vue?vue&type=script&lang=js"
export * from "./ResourceCell.vue?vue&type=script&lang=js"

import "./ResourceCell.vue?vue&type=style&index=0&id=3c3a9d32&lang=scss"

import exportComponent from "../../../../venturestar-data-emails-sentistar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__